'use client';

import TabBar from '@/components/tab-bar';

interface IProps {
    children: React.ReactNode;
}

export default function TabsLayout({ children }: Readonly<IProps>) {
    return (
        <div className='flex size-full justify-center bg-[#F7F7F7] pb-[calc(52px_+_env(safe-area-inset-bottom,0px))]'>
            <div className='mx-auto h-full w-[375px]'>{children}</div>
            <TabBar />
        </div>
    );
}
